/**
 * @module app.core
 */
import { autoinject } from "aurelia-framework";
import { bindable } from 'aurelia-typed-observable-plugin';
import * as Core from 'app/core/models/essette-api';

@autoinject
export class QuestionView {
    ////****************** Fields and Properties ************************************////
    @bindable
    protected question: Core.AssessmentQuestion | null = null;

    @bindable
    protected number: number | null = null;

    @bindable.stringNull()
    protected labelId: string | null = null;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor() { }

    ////****************** Events ***************************************************////

}
